<template>
  <div class="footer bg-white bottomStack" :class="setTabFixed  ? 'fixed-bottom' : ''">
    <div class="divider"></div>
    <div class="container container--narrow pdb-0">
      <div class="d-flex align-items-center justify-content-between pdt-9 pdb-10">
        <div class="d-flex align-items-baseline  t-nowrap">
          <div class="t-body-6 pdr-8 font-r">{{$t("152")}}</div>
          <div class="t-headline5 pdr-8  t-line-h-32" v-if="basicData">{{parseInt(basicData.progression)}}%</div>
        </div>
        <div>
          <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText " v-if="tabType === 'ViewLesson' && nextLessonData" @click="learnLesson(nextLessonData)" tabindex="0">
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body2 font-r t-nowrap">{{$t("154")}}</span>
          </button>
          <button class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText " v-if="tabType === 'ViewExam' && examineeId" @click="takeFinalExam(examineeId)" tabindex="0">
            <div class="mdc-button__ripple"></div>
            <span class="mdc-button__label t-body2 font-r t-nowrap">{{$t("193")}}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 상세 - footer 컴포넌트(my learning view - footer component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
export default {
  props: ['basicData', 'setTabFixed', 'tabType', 'nextLessonData', 'examineeId', 'missionId'],

  data() {
    return {
      nextProgressionId: null
    }
  },

  mounted() {
    this.nextProgressionId = this.nextLessonData ? this.nextLessonData.progressionId : null
    this.setMaterialUi()
  },

  methods: {
    // learn lesson
    learnLesson(lesson) {
      // console.log('this.$route.query 77777===',this.$route.query);
      if (lesson.status.value === "OPENED") {
        if (lesson.contentsType.value === "EXAM_PAPER") {
          let query = this.$route.query;
          query.type='formal-evolution'
          this.$router.push({
            name: "LessonExamIntro",
            params: {
              learnId: this.$route.params.learnId,
              examineeId: lesson.examineeId,
            },
            query: query,
          });
        } else {
          this.$router.push({
            name: "LessonView",
            params: {
              learnId: this.$route.params.learnId,
              lessonId: lesson.id,
              progressionId: lesson.progressionId,
            },
            query: this.$route.query,
          });
        }
      } else {

        this.$alert({
          //title: "Todo-순차학습 안내",
          content: this.$t("1885") + " " + this.$t("1886"),
          accept: this.$t("1887"),
        }).then(() => {
          // console.log('lesson',lesson);
          // this.$router.push({
          //   name: "LessonView",
          //   params: {
          //     learnId: this.$route.params.learnId,
          //     lessonId: lesson.id,
          //     progressionId: lesson.progressionId,
          //   },
          //   query: this.$route.query,
          // });
        });
      }
    },

    // move take mission
    takeMission(missionId) {
      this.$router.push({
        name: 'LearnViewMission',
        params: {
          assignmentId: missionId
        },
        query: this.$route.query
      })
    },

    // move take exam
    takeFinalExam(examineeId) {
      let query = this.$route.query;
      query.type='regular-evolution'
      this.$confirm({
        title: this.$t("1652"),
        content: this.$t("1653") + " <br/>" + this.$t("1654"),
        accept: this.$t("1656"),
        cancel: this.$t("1655"),
      }).then(() => {
        this.$router.push({
          name: 'FinalExamIntro',
          params: {
            learnId: this.$route.params.learnId,
            examineeId: examineeId
          },
          query: query
        })
      }).catch(() => {});
    },
    setMaterialUi() {
      const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
        let button = new MDCRipple.attachTo(el)
        return button
      })
    },
  },

}
</script>
